export default __webpack_public_path__ + "media/icons/whatsapp-bcba16a2.svg";